import { IconButton, Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CommentIcon from '@material-ui/icons/Comment'
import { useTranslation } from 'react-i18next'
import { setCommentSideBarOpen } from 'src/redux/slices/settings'
import { useAppDispatch, useAppSelector } from 'src/utils/hooks/reduxHooks'

const useStyles = makeStyles((theme) => ({
	commentIcon: {
		marginRight: '5px',
		[theme.breakpoints.down(700)]: {
			marginRight: 0,
		},
	},
	button: {
		[theme.breakpoints.down(700)]: {
			paddingRight: 0,
		},
	},
}))

function CommentButton() {
	const { t: tOfflineButton } = useTranslation('OfflineButton')
	const classes = useStyles()
	const dispatch = useAppDispatch()

	const commentSideBarOpen = useAppSelector(
		(state) => state.settings.commentSidebarOpen
	)

	function handleClick(e: any) {
		dispatch(setCommentSideBarOpen(!commentSideBarOpen))
	}

	return (
		<div style={{ marginRight: '5px' }}>
			<span>
				<Tooltip title={tOfflineButton('comment')}>
					<IconButton
						aria-label="comment button"
						aria-controls="button"
						color="inherit"
						className={classes.button}
						onClick={handleClick}
					>
						<CommentIcon className={classes.commentIcon} />
					</IconButton>
				</Tooltip>
			</span>
		</div>
	)
}

export default CommentButton
